import { useCurrentTenant } from "@drift/oneplatfront-components";
import { CodeViewer } from "@onefront/react-workspace-components";
import { ExtendedMenuItem, ExtendedSelect, SectionalsLookup } from "@onefront/workspace-forms";
import { ExtendedTypography } from "@vapor/react-extended";
import { Grid, Stack, TextField } from "@vapor/react-material";
import { useState } from "react";

export const SectionalDemo = () => {
    const { tenant } = useCurrentTenant(true);
    const [sectionalType, setSectionalType] = useState<"PURCHASE" | "SALE" | "">("");
    const [dataViewer, setDataViewer] = useState<any>(null);
    const [selectedSectional, setSelectedSectional] = useState<string | null>(null);

    return (
        <Stack width={"100%"} maxWidth={"1280px"} margin={"0 auto"} gap={3}>
            <Stack direction="row" gap={2} alignItems="center" justifyContent={"space-between"}>
                <ExtendedTypography variant="titleLarge">Sectional Demo</ExtendedTypography>
            </Stack>
            <Grid container rowGap={2} columnGap={2} justifyContent="space-between" alignItems={"center"}>
                <Grid item xs={3.5}>
                    <TextField label={"Tenant Workspace ID"} value={tenant?.id} readOnly />
                </Grid>
                <Grid item xs={3.5}>
                    <ExtendedSelect
                        label={"Sectional Type"}
                        value={sectionalType}
                        onChange={e => setSectionalType(e.target.value as any)}
                        required
                    >
                        <ExtendedMenuItem value={"PURCHASE"} label="ACQUISTO">
                            ACQUISTO
                        </ExtendedMenuItem>
                        <ExtendedMenuItem value={"SALE"} label="VENDITA">
                            VENDITA
                        </ExtendedMenuItem>
                        <ExtendedMenuItem value={"REVERSE_CHARGE"} label="REVERSE CHARGE">
                            REVERSE CHARGE
                        </ExtendedMenuItem>
                        <ExtendedMenuItem value={""} label="SENZA FILTRO">
                            SENZA FILTRO
                        </ExtendedMenuItem>
                    </ExtendedSelect>
                </Grid>
            </Grid>
            <SectionalsLookup
                type={sectionalType !== "" ? sectionalType : undefined}
                workspaceId={tenant?.id /* "57c879ca-8f9d-4faa-920d-738eb9e024ac"*/}
                onSelect={(data: any) => {
                    setSelectedSectional(data?.id);
                    setDataViewer(data);
                }}
                selected={selectedSectional}
                onClear={() => {
                    setSelectedSectional(null);
                }}
            />
            <CodeViewer json={dataViewer} label="onSelect Data" display />
        </Stack>
    );
};
